import { ILegalEntityOption } from './types';

const actions = {
  LEGAL_ENTITIES_OPTIONS_FETCH_REQUEST: 'LEGAL_ENTITIES_OPTIONS_FETCH_REQUEST',
  LEGAL_ENTITIES_OPTIONS_FETCH_SUCCESS: 'LEGAL_ENTITIES_OPTIONS_FETCH_SUCCESS',
  LEGAL_ENTITIES_OPTIONS_FETCH_ERROR: 'LEGAL_ENTITIES_OPTIONS_FETCH_ERROR',

  fetchOptions: () => ({ type: actions.LEGAL_ENTITIES_OPTIONS_FETCH_REQUEST }),

  fetchOptionsSuccess: (data: ILegalEntityOption[]) => ({
    type: actions.LEGAL_ENTITIES_OPTIONS_FETCH_SUCCESS,
    payload: data,
  }),

  fetchOptionsError: () => ({ type: actions.LEGAL_ENTITIES_OPTIONS_FETCH_ERROR }),
};

export default actions;
